import { createRouter, createWebHashHistory } from 'vue-router';




const routes = [
  {
    path: "/landing-page",
    name: "LandingPage",
    component: () => import('../views/home-page/home-page.vue')
  },
  {
    path: "/start-calculation-page",
    name: "StartCalculation",
    component: () => import('../views/start-calculation/start-calculation.vue')
  },
  {
    path: "/spending-page",
    name: "SpendingScreen",
    component: () => import('../views/spending-screen/spending-screen.vue')
  },
  {
    path: "/calculation-page",
    name: "CalculationScreen",
    component: () => import('../views/calculate-screen/calculate-screen.vue')
  },
  {
    path:'/result-page',
    name: "ResultScreen",
    component: () => import('../views/result-screen/result-screen.vue')
  },
  {
    path: "/calculation-explanation-page",
    name: "CalculationMethodScreen",
    component: () => import('../views/calculation-method/calculation-method.vue')
  },
  {
    path: "/recalculate-page",
    name: "RecalculationScreen",
    component: () => import('../views/recalculate-screen/recalculate-screen.vue')
  },
  {
    path: '/maintenance-page',
    name: "MaintainanceScreen",
    component: () => import('../views/maintainance-screen/maintainance-screen.vue')
  },
  {
    path: '/',
    redirect: '/landing-page'
  }
]
const router = createRouter({
  // hash is default, history doesn't work on azure
  history: createWebHashHistory(),
  routes,
});

// const router = new VueRouter({
//   routes
// })

export default router;
